import { j as o } from "./index.es33.js";
import { Tooltip as p } from "./index.es13.js";
import "react";
import "nanoid";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import "./index.es36.js";
import "./index.es15.js";

var g = function g(_ref) {
  var i = _ref.isDisabled,
      r = _ref.disabledTooltipText,
      t = _ref.children;
  return r ? o.jsx(p, {
    isVisibleDisabled: !i,
    title: r,
    children: t
  }) : t;
};

export { g as OptionWrapper };